<template>
  <!-- 客户列表（商户后台） -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="请输入客户名称/手机号" @keydown.enter="resetSearch" clearable>
            <template #prefix>关键字</template>
          </el-input>
          <!-- 客户类型/行业/软件类型走字典；是否云客户、负责人与往来类型不同，见各自的常量与组件 -->
          <el-select v-model="searchInfo.customerType" placeholder="全部" clearable>
            <template #prefix>客户类型</template>
            <el-option v-for="d in customerTypeList" :key="d.userCode" :label="d.dictName" :value="d.userCode"/>
          </el-select>
          <el-select v-model="searchInfo.industryId" placeholder="全部" clearable filterable>
            <template #prefix>所属行业</template>
            <el-option v-for="d in industryList" :key="d.userCode" :label="d.dictName" :value="d.userCode"/>
          </el-select>
          <el-select v-model="searchInfo.cloudType" placeholder="全部" clearable>
            <template #prefix>是否云客户</template>
            <el-option label="是" :value="CLOUD_TYPE.YES"/>
            <el-option label="否" :value="CLOUD_TYPE.NO"/>
          </el-select>
          <el-select v-model="searchInfo.softType" placeholder="全部" clearable>
            <template #prefix>软件类型</template>
            <el-option v-for="d in softTypeList" :key="d.userCode" :label="d.dictName" :value="d.userCode"/>
          </el-select>
          <!-- 负责人关系在 ba_business_partner_employee，由后端按档案id关联筛 -->
          <employee-select v-model="searchInfo.ownerEmployeeId" placeholder="全部" @change="resetSearch">
            <template #prefix>负责人</template>
          </employee-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="router.push(`/customer/list/detail`)">新建</page-button>
          <page-button type="write" el-type="warning" :disabled="importStatus.running"
                       @click="showImport = true">{{ importStatus.running ? "导入中..." : "导入客户" }}</page-button>
          <page-button type="read" el-type="success" @click="exportList">导出</page-button>
        </template>
      </search-condition>
      <list-table :show-shadow="false">
        <!-- 导入客户：模板为“客户数据导入”模板 -->
        <import-component ref="importComponent" v-model="showImport" title="导入客户"
                          :import-by-excel="handleImport" @export-temp="downloadTemplate"/>
        <separator-page :show-border="true">
          <template #category>
            <tree-dictionary :filter="true" v-model:dictionary-list="customerCategoryTree" dictionary-type="CUSTOMER_CATEGORY" @clickCategory="clickCategory" dialog-label="客户分类管理">
            </tree-dictionary>
          </template>
          <template #default>
            <yq-table :data="dataList" height="100%" stripe border page-name="customer" app-name="basedata">
              <yq-table-column  label="客户名称" prop="merchantRemarkName" min-width="180rem"/>
              <yq-table-column label="联系电话" prop="merchantRemarkPhone" min-width="120rem"/>
              <!-- 往来类型：1个人 0公司，是客户本体的类型，不是「客户类型」 -->
              <yq-table-column label="往来类型" prop="contactType">
                <template v-slot="{row}">
                  <el-tag v-if="row.contactType === CONTACT_TYPE.PERSON">个人</el-tag>
                  <el-tag v-if="row.contactType === CONTACT_TYPE.COMPANY">公司</el-tag>
                </template>
              </yq-table-column>
              <yq-table-column label="客户类型" prop="customerType" min-width="120rem">
                <template v-slot="{row}">{{ dictName(customerTypeList, row.customerType) || '—' }}</template>
              </yq-table-column>
              <yq-table-column label="所属行业" prop="industryId" min-width="120rem">
                <template v-slot="{row}">{{ dictName(industryList, row.industryId) || '—' }}</template>
              </yq-table-column>
              <yq-table-column label="是否云客户" prop="cloudType" width="120rem" align="center">
                <template v-slot="{row}">
                  <el-tag v-if="Number(row.cloudType) === CLOUD_TYPE.YES" type="success" size="small">是</el-tag>
                  <el-tag v-else-if="row.cloudType !== null && row.cloudType !== undefined && row.cloudType !== ''" type="info" size="small">否</el-tag>
                  <span v-else>—</span>
                </template>
              </yq-table-column>
              <yq-table-column label="联系人" prop="merchantRemarkContact" min-width="120rem"/>
              <yq-table-column label="客户来源" prop="sourceDictId" min-width="120rem">
                <template v-slot="{row}">
                  <el-tag v-if="dictName(sourceList, row.sourceDictId)" size="small" type="info">{{ dictName(sourceList, row.sourceDictId) }}</el-tag>
                  <span v-else>—</span>
                </template>
              </yq-table-column>
              <yq-table-column label="地区" prop="merchantRegion">
                <template v-slot="{row}">
                  <administrative v-model="row.merchantRegion" :disabled="true"/>
                </template>
              </yq-table-column>
              <yq-table-column label="负责人" prop="ownerEmployeeName" width="100rem"/>
              <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="180rem" :show-overflow-tooltip="false">
                <template v-slot="{row}">
                  <table-button-group label="更多操作">
                    <table-button @click="router.push(`/customer/list/info?id=${row.id}`)">详情</table-button>
                    <table-button @click="router.push(`/customer/list/detail?id=${row.id}`)">编辑</table-button>
                    <table-button  el-type="danger" message="是否确认删除数据" @click="toDelete(row)">删除</table-button>
                  </table-button-group>
                </template>
              </yq-table-column>
            </yq-table>
          </template>
        </separator-page>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import customerApi from "@/api/normal/common/customerApi";
import commonApi from "@/api/commonApi";
import Administrative from "@/components/h5/data/Administrative.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import excelUtil from "@/util/excelUtil";
import {
  CLOUD_TYPE, CONTACT_TYPE, DICT_CUSTOMER_TYPE, DICT_CUSTOMER_SOFT_TYPE, DICT_INDUSTRY_TYPE, DICT_PARTNER_ORIGIN, dictName
} from "@/views/h5/crm/crmDictionary";
import PrintButton from "@/views/h5/common/print/template/print-button.vue";
import ImportComponent from "@/components/h5/ImportComponent.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    ImportComponent,
    SeparatorPage, PrintButton,
    Administrative,
    EmployeeSelect,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage, TreeDictionary, FormItems, FormItem
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      showImport: false,
      // 导入状态：后端异步导入，前端每5秒轮询一次
      importStatus: {running: false, status: "NONE"},
      importPollTimer: null,
      // 只有当前页面发起的导入（或进入页面时正在导入）才在完成时提示结果
      importPollingNotified: false,
      customerCategoryTree: [],
      // 字典：客户类型/所属行业/软件类型/客户来源，后端只返回值不返回名称，这里拉回来自己关联
      customerTypeList: [],
      industryList: [],
      softTypeList: [],
      sourceList: [],
      // 常量暴露给模板用
      CLOUD_TYPE, CONTACT_TYPE,
    };
  },
  beforeRouteLeave(to, from, next) {
    this.stopImportPolling();
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  unmounted() {
    this.stopImportPolling();
  },
  created() {
    this.initDictionary();
    this.resetSearch();
    this.initImportStatus();
  },
  methods: {
    dictName,
    initDictionary() {
      commonApi.queryUniqueDictionaryList(DICT_CUSTOMER_TYPE).then(list => this.customerTypeList = list || []);
      commonApi.queryUniqueDictionaryList(DICT_INDUSTRY_TYPE).then(list => this.industryList = list || []);
      commonApi.queryUniqueDictionaryList(DICT_CUSTOMER_SOFT_TYPE).then(list => this.softTypeList = list || []);
      commonApi.queryUniqueDictionaryList(DICT_PARTNER_ORIGIN).then(list => this.sourceList = list || []);
    },
    // 返回
    getDetail(row) {
      return {"stockName": "小圆1号仓库", "deptName": "销售部", "userName": "小圆圆", "table1": [
          {"productName": "水杯", "spec": "100ml大号", "displayQty": 100, "price": "99.00"},
          {"productName": "水壶", "spec": "300ml超大号", "displayQty": 20, "price": "199.00"},
          {"productName": "水杯", "spec": "1000ml红色大号", "displayQty": 90, "price": "299.00"}
        ]}
    },
    // 点击分类
    clickCategory(data) {
      this.searchInfo.category = data.dictCode;
      this.resetSearch();
    },
    queryList() {
      customerApi.queryList(this.buildParams()).then(res => {
        this.dataList = res.records || [];
        this.searchInfo.totalCount = res.totalCount;
      });
    },
    /** 空值不提交，避免空串绑到后端 Integer（cloudType）报错 */
    buildParams() {
      const params = {};
      Object.keys(this.searchInfo).forEach(k => {
        const v = this.searchInfo[k];
        if (v === "" || v === null || v === undefined || k === "totalCount") {
          return;
        }
        params[k] = v;
      });
      return params;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    /** 下载导入模板 */
    downloadTemplate() {
      excelUtil.exportExcel("/basedata/partner/customer/exportTemp", {}, "客户数据导入模板.xlsx");
    },
    /** 上传回调：后台异步导入，接口立即返回，前端轮询导入状态 */
    handleImport(formData) {
      return customerApi.importExcel(formData).then(() => {
        this.$message.success("客户正在导入中，请稍后查询");
        this.showImport = false;
        this.importStatus = {running: true, status: "RUNNING"};
        this.importPollingNotified = true;
        // 清掉通用组件里选中的文件，下次打开不要还挂着上一次的文件
        if (this.$refs.importComponent) {
          this.$refs.importComponent.fileList = [];
          this.$refs.importComponent.file = "";
        }
        this.startImportPolling();
      }).catch(() => {
        // 上一次导入未完成等错误由请求拦截器提示，这里同步一下真实状态
        this.initImportStatus();
      });
    },
    /** 进入页面先查一次：如果后台正在导入，继续轮询 */
    initImportStatus() {
      customerApi.importStatus().then(status => {
        this.importStatus = status || {running: false, status: "NONE"};
        if (this.importStatus.running) {
          this.importPollingNotified = true;
          this.startImportPolling();
        }
      });
    },
    startImportPolling() {
      if (this.importPollTimer) {
        return;
      }
      this.importPollTimer = setInterval(this.pollImportStatus, 5000);
    },
    stopImportPolling() {
      if (this.importPollTimer) {
        clearInterval(this.importPollTimer);
        this.importPollTimer = null;
      }
    },
    pollImportStatus() {
      customerApi.importStatus().then(status => {
        this.importStatus = status || {running: false, status: "NONE"};
        if (this.importStatus.running) {
          return;
        }
        this.stopImportPolling();
        if (!this.importPollingNotified) {
          return;
        }
        this.importPollingNotified = false;
        if (status.status === "SUCCESS") {
          this.$message.success(status.message || "客户导入完成");
          this.resetSearch();
        } else if (status.status === "FAILED") {
          this.$message.error("客户导入失败：" + (status.message || "请查看后台日志"));
        }
      }).catch(() => {
        // 轮询失败不停止，下一次继续
      });
    },
    /** 导出当前查询条件下的全部客户（数据权限由后端按列表同一套规则收口） */
    exportList() {
      const params = this.buildParams();
      params.pageNumber = 1;
      excelUtil.exportExcel("/basedata/partner/customer/exportList", params, "客户数据.xlsx");
    },
    toDelete(data) {
      customerApi.delete(data.id).then(() => {
        this.queryList();
      })
    },

  }
};
</script>

<style lang="scss" scoped>
.importing-tip {
  margin-left: 10px;
  font-size: 12px;
  color: var(--el-color-warning, #e6a23c);
}
</style>
